import { PersonFormModel } from '@base/models/form/person-form.model';
import { PaymentFormModel } from '@base/models/form/payment-form.model';

export function checkForPersonDataInUrl(url: URL, personForm: PersonFormModel): PersonFormModel {
  if (!personForm.firstname.value && url.searchParams.has('firstname')) {
    personForm.firstname.setValue(url.searchParams.get('firstname'));
  }

  if (!personForm.lastname.value && url.searchParams.has('lastname')) {
    personForm.lastname.setValue(url.searchParams.get('lastname'));
  }

  if (!personForm.email.value && url.searchParams.has('email')) {
    personForm.email.setValue(url.searchParams.get('email'));
  }

  if (!personForm.phone.value && url.searchParams.has('phone')) {
    personForm.phone.setValue(url.searchParams.get('phone'));
  }

  if (!personForm.address.controls.street.value && url.searchParams.has('street')) {
    personForm.address.controls.street.setValue(url.searchParams.get('street'));
  }

  if (!personForm.address.controls.houseNumber.value && url.searchParams.has('houseNumber')) {
    personForm.address.controls.houseNumber.setValue(url.searchParams.get('houseNumber'));
  }

  if (!personForm.address.controls.city.value && url.searchParams.has('city')) {
    personForm.address.controls.city.setValue(url.searchParams.get('city'));
  }

  if (!personForm.address.controls.zip.value && url.searchParams.has('zip')) {
    personForm.address.controls.zip.setValue(url.searchParams.get('zip'));
  }

  return personForm;
}

export function checkForPaymentInfoInUrl(url: URL, paymentForm: PaymentFormModel): PaymentFormModel {
  if (!paymentForm.iban.value && url.searchParams.has('iban')) {
    paymentForm.iban.setValue(url.searchParams.get('iban'));
  }

  return paymentForm;
}